import classNames from 'classnames';
import * as React from 'react';
import { ButtonType } from '../Button/ButtonType.csharp';
import type { AlertSectionProps } from '~/Partials/AlertSection/AlertSection';
import { AlertSection } from '~/Partials/AlertSection/AlertSection';
import { Button } from '~/Partials/Button/Button';
import { Collapse } from '~/Partials/Collapse/Collapse';
import { SvgIcon } from '~/Partials/SvgIcon/SvgIcon';
import styles from './CollapsibleAlertSection.module.css';

export interface CollapsibleAlertSectionTranslations {
    close: string;
}

interface CollapsibleAlertSectionProps extends AlertSectionProps {
    translations: CollapsibleAlertSectionTranslations;
    animateOnEnter?: boolean;
    onClose?: () => void;
    className?: string;
}

export const CollapsibleAlertSection: React.FC<React.PropsWithChildren<CollapsibleAlertSectionProps>> = props => {
    const { translations, onClose, className, animateOnEnter = false, ...sectionProps } = props;
    const [isVisible, setIsVisible] = React.useState(!animateOnEnter);

    React.useEffect(() => {
        animateOnEnter && setIsVisible(true);
    }, []);

    const onTransitionEnded = () => {
        if (onClose && !isVisible) {
            onClose();
        }
    };

    const handleCloseClick = () => setIsVisible(false);

    return (
        <Collapse
            isOpen={isVisible}
            className={classNames(styles.CollapsibleAlertSection, !isVisible && styles['Variant--hidden'], className)}
            onRest={onTransitionEnded}
            withMarginTransition
        >
            <AlertSection {...sectionProps} />
            <Button onClick={handleCloseClick} className={styles.CloseButton} type={ButtonType.Clear}>
                <SvgIcon iconName="close" />
                <span className="visuallyHidden">{translations.close}</span>
            </Button>
        </Collapse>
    );
};
